// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "quill" + "." + "7e760da2440500e8" + ".js";
};